// ** React Imports
import { useState, useEffect } from "react";

// ** Data (Flix transport: @salespark/api-client)
import { flixCoursesList } from "src/flix/api/flix";

/******************************************************************
 * ##: useFlixCatalog
 * Loads the learner's course list for the Flix catalog via the Flix-only
 * endpoint (`flixCoursesList` -> GET /users/flix/courses), which splits
 * flag-enabled courses into one card per purchased turma/class and returns
 * every other course unchanged. Uses @salespark/api-client, so the call
 * resolves the SalesPark { status, data } contract directly (no wrapper).
 * Flix pages stay presentation only.
 * @param {Object} authUser - auth.user (carries email + token for headers)
 * @returns {Object} - { loading, error, courses }
 * History:
 * 22-07-2026: Created
 * 16-09-2026: Switched to the Flix-only /users/flix/courses endpoint (per-pack cards)
 * 16-09-2026: Migrated transport to @salespark/api-client (flixCoursesList)
 ******************************************************************/
export const useFlixCatalog = (authUser) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    let active = true;
    if (!authUser) return undefined;

    (async () => {
      const response = await flixCoursesList(authUser);
      if (!active) return;
      if (!response.status) {
        setError(true);
      } else {
        setCourses(Array.isArray(response.data) ? response.data : []);
      }
      setLoading(false);
    })();

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  return { loading, error, courses };
};

export default useFlixCatalog;
